import { NbDialogService } from '@nebular/theme';
import { BaseComponent } from './../../../../shared/Components/base/base.component';
import { PagingService } from './../../../../shared/Services/PagingService';
import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { VisitTypeService } from '../../services/visit-type-service';
import { AddVisitTypeComponent } from '../add-visit-type/add-visit-type.component';
import { DeleteConfirmationComponent } from '../../../delete-confirmation/delete-confirmation.component';

@Component({
  selector: 'app-get-visit-types',
  templateUrl: './get-visit-types.component.html',
  styleUrls: ['./get-visit-types.component.scss'],
})
export class GetVisitTypesComponent extends BaseComponent implements OnInit {
  constructor(
    public service: VisitTypeService,
    public route: Router,
    public paging: PagingService,
    private diag: NbDialogService
  ) {
    super(route, service, paging, '');
  }

  ngOnInit() {
    this.loadEntities();
  }

  add() {
    this.diag.open(AddVisitTypeComponent).onClose.subscribe((res) => {
      if (res === 'true') this.loadEntities();
    });
  }

    delete(id) {
    this.diag.open(DeleteConfirmationComponent, {
      dialogClass: 'custom-dialog-height',
      context: {
        id: id,
        service: this.service,
        url:this.route.url
      },
    });
  }
  
  update(visitType) {
    const copymodel = {...visitType}
    this.diag.open(AddVisitTypeComponent, { context: { sType: copymodel, isEdit: true } }).onClose.subscribe((res) => {
      if (res === 'true') {
        this.loadEntities();
      }
    });
  }
}
